import {
  BOOKING_PROCESS_START,
  BOOKING_PROCESS_SUCCESS,
  BOOKING_PROCESS_ERROR,
  GET_SERVICE_FEES_SUCCESS,
  BOOKING_PAYMENT_START,
  BOOKING_PAYMENT_ERROR,
  BOOKING_PAYMENT_FOR_CANCEL_START,
  BOOKING_PAYMENT_FOR_CANCEL_ERROR,
} from '../constants';
import { isDev } from '../config';

const defaultBookLive = {};

const defaultBookTest = {
  data: {
    id: 424,
    userId: '8e8b3a00-91e8-11e9-812a-7b4417005c83',
    title: 'Razor DXT Drift Trike',
    coverPhoto: 967,
    basePrice: 10,
    category: 91,
    listingAddresses: [{ city: 'Provo', state: 'UT' }],
    listPhotos: [{ id: 967, name: '133c6a3925c90aedb87ba5fb44f9fe6d.jpeg' }],
    user: {
      email: 'rentals@yoodlize.com',
      profile: {
        profileId: 262,
        displayName: 'Jayme Schow',
        firstName: 'Jayme',
        picture: '61c553b9434e00ad6c14a51b6e0e3136.jpeg',
      },
    },
    listingRules: [
      { listingRulesId: null, description: 'Phone number on file required' },
      { listingRulesId: null, description: 'Document Verification required' },
    ],
  },
  bookDetails: {
    units: 2,
    guests: 1,
    startDate: '2020-05-03',
    endDate: '2020-05-05',
  },
};

const defaultBook = isDev ? defaultBookTest : defaultBookLive;

export default function book(state = defaultBook, action) {
  switch (action.type) {
    case BOOKING_PROCESS_START:
      return {
        ...state,
        data: null,
        bookDetails: null,
        bookingLoading: action.payload.bookingLoading,
      };

    case BOOKING_PROCESS_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        bookDetails: action.payload.bookDetails,
        bookingLoading: action.payload.bookingLoading,
      };

    case BOOKING_PROCESS_ERROR:
      return {
        ...state,
        bookingLoading: action.payload.bookingLoading,
      };

    case BOOKING_PAYMENT_START:
      return {
        ...state,
        paymentLoading: action.payload.paymentLoading,
      };

    case BOOKING_PAYMENT_ERROR:
      return {
        ...state,
        paymentLoading: action.payload.paymentLoading,
      };

    case BOOKING_PAYMENT_FOR_CANCEL_START:
      return {
        ...state,
        paymentLoading: action.payload.paymentLoading,
      };

    case BOOKING_PAYMENT_FOR_CANCEL_ERROR:
      return {
        ...state,
        paymentLoading: action.payload.paymentLoading,
      };

    case GET_SERVICE_FEES_SUCCESS:
      return {
        ...state,
        serviceFees: action.payload.serviceFees,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/book.js